const KNOWN_BANK_NAMES: Record<string, string> = {
    ABNAMRO_ABNANL2A: 'ABN AMRO Bank',
    AIRWALLEX_EEA_AIPTAU32: 'Airwallex',
    ASN_BANK_ASNBNL21: 'ASN Bank',
    BUNQ_BUNQNL2A: 'bunq',
    FINOM_FNOMDEB2: 'Finom',
    HANDELSBANKEN_CORPORATE_HANDNL2A: 'Handelsbanken Corporate',
    HANDELSBANKEN_HANDNL2A: 'Handelsbanken Private',
    ING_INGBNL2A: 'ING',
    ING_WB_INGBNL2A: 'ING',
    KNAB_KNABNL2H: 'Knab',
    MOLLIE_MLLENL2AXXX: 'Mollie',
    MONESE_MNEEBEB2: 'Monese',
    N26_NTSBDEB1: 'N26 Bank',
    NN_BANK_NNBANL2G: 'NN Bank',
    PAYMENT_MOLLIE_NL: 'Mollie',
    PAYPAL_PPLXLULL: 'PayPal',
    QONTO_QNTOFRP1: 'Qonto',
    RABOBANK_NL: 'Rabobank',
    RABOBANK_RABONL2U: 'Rabobank',
    REGIOBANK_RBRBNL21: 'RegioBank',
    REVOLUT_REVOLT21: 'Revolut',
    SNS_BANK_SNSBNL2A: 'SNS Bank',
    STRIPE_STPUIE21: 'Stripe',
    SWAN_SWNBFR22: 'Swan',
    TRIODOS_TRIONL2U: 'Triodos Bank',
    VAN_LANSCHOT_KEMPEN_KEMPNL2A: 'Van Lanschot Kempen',
    VIVID_VVIDLUL2: 'Vivid Money',
    WISE_EEA_TRWIGB22: 'Wise',
};

const ACRONYM_MAX_LENGTH = 3;

function nameFromInstitutionId(institutionId: string): string {
    if (!/^[A-Z0-9_]+$/.test(institutionId)) {
        return institutionId;
    }
    const segments = institutionId.split('_');
    const nameWords = segments.length > 1 ? segments.slice(0, -1) : segments;
    return nameWords
        .map((word) => (word.length <= ACRONYM_MAX_LENGTH ? word : word.charAt(0) + word.slice(1).toLowerCase()))
        .join(' ');
}

export function bankDisplayName(institutionId: string): string {
    const trimmed = institutionId.trim();
    return KNOWN_BANK_NAMES[trimmed] ?? (nameFromInstitutionId(trimmed) || 'Bankrekening');
}
